import { render, staticRenderFns } from "./AiVoiceIcon.vue?vue&type=template&id=c957ad24&scoped=true"
import script from "./AiVoiceIcon.vue?vue&type=script&lang=js"
export * from "./AiVoiceIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c957ad24",
  null
  
)

export default component.exports